var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18.5C14 18.2239 13.7761 18 13.5 18H12.5C12.2239 18 12 18.2239 12 18.5C12 18.7761 12.2239 19 12.5 19H13.5C13.7761 19 14 18.7761 14 18.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18.5C15 18.2239 15.2239 18 15.5 18H16.5C16.7761 18 17 18.2239 17 18.5C17 18.7761 16.7761 19 16.5 19H15.5C15.2239 19 15 18.7761 15 18.5Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5C20 18.2239 19.7761 18 19.5 18H18.5C18.2239 18 18 18.2239 18 18.5C18 18.7761 18.2239 19 18.5 19H19.5C19.7761 19 20 18.7761 20 18.5Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C9.89543 11 9 11.8954 9 13V19C9 20.1046 9.89543 21 11 21H21C22.1046 21 23 20.1046 23 19V13C23 11.8954 22.1046 11 21 11H11ZM21 12H11C10.4477 12 10 12.4477 10 13V14H22V13C22 12.4477 21.5523 12 21 12ZM10 19V16H22V19C22 19.5523 21.5523 20 21 20H11C10.4477 20 10 19.5523 10 19Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.72cfbca8834671b3d36d0bea170fd04b.svg";
export { ForwardRef as ReactComponent };